import { LogLevel } from '../app/app.service';

export const environment = {
  production: true,
  test: false,
  firebase: {
    apiKey: 'AIzaSyAAKNVFGAdu8TUqs069YOyGXblLpXhkgJI',
    authDomain: 'monsuividiet.facteur-dev.fr', //'xdev-develop.firebaseapp.com',
    projectId: 'xdev-develop',
    storageBucket: 'xdev-develop.appspot.com',
    messagingSenderId: '736161127579',
    appId: '1:736161127579:web:ff9eccc8d887bf510f3a3e',
    measurementId: 'G-W2NLMJQ9BZ',
  },
  firebaseFunctionsUrl: 'https://europe-west1-xdev-develop.cloudfunctions.net/',
  monthlySubscription: {
    price: 'price_1LAsgxI0uyVAlrPMDWntz89S',
    product: 'prod_Lsdy1bFjEHZOZE',
  },
  yearlySubscription: {
    price: 'price_1NDlklI0uyVAlrPMqhqrMtQi',
    product: 'prod_Lsdy1bFjEHZOZE',
  },
  monSuiviDietPlus: {
    urlApi: 'https://monsuividietplus.com/version-test/api/1.1/wf',
    secret:
      '7c190ca502d8343e19b563bd92b07ae545f69bb2265b5e59b284ed7f78c731b0bbf47f29951894e7ba2983f80694fcf8029acc1b8699ac0dc521162a19c552d7',
  },
  verbosity: LogLevel.debug,
  patient: {
    protocol: 'https',
    domain: 'msd-patient.facteur-dev.fr',
    port: undefined,
  },
  dietitian: {
    protocol: 'https',
    domain: 'monsuividiet.facteur-dev.fr',
    port: undefined,
  },
  vapid:
    'BBlPSN8dmMa53YvkyNDvnhXZMlAlkEoiMqCGtoEkGGcctCyzV0pda8qxSEyPpTebkd14yIKE2PKdPKDWz5kTMnM',
  superPDP: {
    endpoint: 'https://api.superpdp.tech',
    redirectUri: 'http://localhost:4200/e-invoicing/register',
    clientId: '019e4546-d1a3-75bf-8d9a-85621e977018',
    clientSecret: 'LxkVM5bTolQUl70rehgfwzbL2IfEZtPTzINVnA',
  },
};
